import { render, staticRenderFns } from "./avatar-input.vue?vue&type=template&id=66ba0c5f"
import script from "./avatar-input.vue?vue&type=script&lang=js"
export * from "./avatar-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports